jQuery(document).ready(function($) {
	var formatNumber = function(number) {
		if (number.indexOf(".") >= 0) {
			return $("html").attr("lang") == "no" ? number.replace(".", ",") : number;
		} else if (number.length > 3) {
			var replacementCharacter = $("html").attr("lang") == "no" ? " " : ",";
			return number.replace(/.{3}$/, replacementCharacter + "$&");
		} else {
			return number;
		}
	};
	var delay = 0;	
	$(".tile-number").each(function() {
		delay = delay + 200;
		var numberToCount = $(this);
		var formattedNumber = $(this).text().replace(",", ".");
		var numberSuffix = formattedNumber.replace(/\d+/g, "").replace(",", "").replace(".", "");
		var numberParts = formattedNumber.split(".");
		var numberDecimals = numberParts.length === 2 ? numberParts[1].length : 1;
		$(this).prop("Counter", 0).delay(delay).animate({
			Counter: formattedNumber
		}, {
			duration: 2000,
			easing: "swing",
			step: function(now) {
				var s = now.toString();
				s = s.substr(0, s.indexOf(".") === -1 ? s.length : s.indexOf(".") + (1 + numberDecimals));
				s = formatNumber(s);
				numberToCount.text(s + numberSuffix);
			}
		});
	});
});
